var parent = document.querySelector('body');
parent.addEventListener('change', function(event) {
    var fileInput = event.target.closest('.file_input');
    if (fileInput) {
        var file = fileInput.files[0].name;
        var input = fileInput.closest('.card-body.py-4').querySelector('.file_name_input');
        input.value = file;
        console.log(fileName);
    }
});